import { useQuery } from '@tanstack/react-query'

import { fetchMetadataList } from '../api'
import { reportsKeys } from '../queryKeys/reportsKeys'

const useGetMetadataListQuery = () => {
  const getMetadataListQuery = useQuery(reportsKeys.metadataList(), () =>
    fetchMetadataList()
  )

  return getMetadataListQuery
}

export default useGetMetadataListQuery
